CustomTC.define('jquery/css/var/cssExpand',[],function() {
	return [ "Top", "Right", "Bottom", "Left" ];
});

